<template>
    <div v-wechat-title="title" class="schedulesetup">
        <el-row type="flex" justify="start" style="height: 46px; padding-left: 10px; border-bottom: 2px solid #ebeef5; margin-bottom: 4px">
            <el-tabs v-model="activeScheduleId">
                <el-tab-pane v-for="schedule in schedules" :key="schedule.id" :label="schedule.name" :name="schedule.id"> </el-tab-pane>
            </el-tabs>
        </el-row>
        <el-row style="height: 46px; border-bottom: 2px solid #ebeef5">
            <el-col :span="4" class="ver-hori-center" :style="{ height:'100%' }">
                <el-radio-group v-model="scheduleSet_Type" size="small">
                    <el-radio-button label="userGroup">按人员</el-radio-button>
                    <el-radio-button label="shift">按班次</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="18" style="display:flex;align-items: center;height: 100%" v-if="viewType=='week'">
                <el-button-group style="margin-right:100px;" class="btn-group-custom-style">
                    <el-button size="small" :type="viewType=='day' ? 'primary' : 'plain'" @click="viewType='day'">日</el-button>
                    <el-button size="small" type="primary">周</el-button>
                    <el-button size="small" :type="viewType=='month' ? 'primary' : 'plain'" @click="viewType='month'">月</el-button>
                </el-button-group>
                <el-button-group>
                    <el-button size="small" @click="addDate(-1)">上一周</el-button>
                    <el-button size="small" @click="addDate(0)">本周</el-button>
                    <el-button size="small" @click="addDate(1)">下一周</el-button>
                </el-button-group>

                <el-date-picker
                    ref="weekPicker"
                    size="small"
                    prefix-icon=""
                    v-model="dateValue"
                    :format="start + ' - ' + end"
                    :picker-options="onPicker"
                    type="week"
                    placeholder="选择周"
                    :style="{ margin:'0 5px' }"
                >
                </el-date-picker>
                <el-button size="small" @click="publishHisRecord">发布记录</el-button>
            </el-col>
            <el-col :span="18" style="display:flex;align-items: center;height: 100%"  v-else-if="viewType=='month'">
                <el-button-group style="margin-right:100px;" class="btn-group-custom-style">
                    <el-button size="small" :type="viewType=='day' ? 'primary' : 'plain'" @click="viewType='day'">日</el-button>
                    <el-button size="small" :type="viewType=='week' ? 'primary' : 'plain'" @click="viewType='week'">周</el-button>
                    <el-button size="small" type="primary">月</el-button>
                </el-button-group>
                <el-button-group>
                    <el-button size="small" @click="addDate(-1)">上一月</el-button>
                    <el-button size="small" @click="addDate(0)">本月</el-button>
                    <el-button size="small" @click="addDate(1)">下一月</el-button>
                </el-button-group>
                <el-date-picker
                    ref="weekPicker"
                    size="small"
                    prefix-icon=""
                    v-model="dateValue"
                    type="month"
                    placeholder="选择月"
                    :style="{ margin:'0 5px' }"
                >
                </el-date-picker>
                <el-button size="small" @click="publishHisRecord">发布记录</el-button>
            </el-col>
            <el-col :span="18" style="display:flex;align-items: center;height: 100%" v-else>
                <el-button-group style="margin-right:100px;" class="btn-group-custom-style">
                    <el-button size="small" type="primary">日</el-button>
                    <el-button size="small" :type="viewType=='week' ? 'primary' : 'plain'" @click="viewType='week'">周</el-button>
                    <el-button size="small" :type="viewType=='month' ? 'primary' : 'plain'" @click="viewType='month'">月</el-button>
                </el-button-group>
                <el-button-group>
                    <el-button size="small" @click="addDate(-1)">上一日</el-button>
                    <el-button size="small" @click="addDate(0)">今日</el-button>
                    <el-button size="small" @click="addDate(1)">下一日</el-button>
                </el-button-group>
                <el-date-picker
                    ref="weekPicker"
                    size="small"
                    prefix-icon=""
                    v-model="dateValue"
                    type="date"
                    placeholder="选择日期"
                    :style="{ margin:'0 5px' }"
                >
                </el-date-picker>
                <el-button size="small" @click="publishHisRecord">发布记录</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="4" style="border-right: 2px solid #ebeef5">
                <div class="userlisttitle">
                    <i class="el-icon-user-solid"></i>

                    {{ scheduleSet_Type == 'shift' ? '人员列表' : '班次列表' }}
                </div>
                <el-scrollbar :style="{ height: `${this.screenHeight2 - 260}px` }">
                    <div v-if="scheduleSet_Type == 'shift'">
                        <el-menu :unique-opened="false" :default-openeds="openeds">
                            <template v-for="g in schedule_userGroup">
                                <el-submenu :index="g.id.toString()" :key="g.id" class="usergroup" style="padding: 0 0px !important">
                                    <div slot="title" style="padding: 0 0px; font-size: 16px">
                                        <h1 style="text-align: left; padding: 0px 30px 0px 12px; margin: 8px 0px 8px 0px">
                                            {{ g.name }}<span class="fg-info">({{ (g.users && g.users.length) || 0 }})</span>
                                        </h1>
                                    </div>
                                    <draggable class="padding-left10" tag="div" v-model="g.users" v-bind="userDragOption" v-if="g.users && g.users.length > 0">
                                        <template v-for="d in g.users">
                                            <el-menu-item class="user" :key="d.worker_id">
                                                {{ d.worker_name }}
                                            </el-menu-item>
                                        </template>
                                    </draggable>
                                </el-submenu>
                            </template>
                        </el-menu>
                    </div>
                    <div v-else>
                        <draggable class="padding-left10" tag="div" v-model="schedule_sifts" v-bind="shiftDragOption">
                            <div class="shift" v-for="g in schedule_sifts" :key="g.dic_shift_id">{{ g.dic_shift_name }}</div>
                        </draggable>
                    </div>
                </el-scrollbar>
            </el-col>
            <el-col :span="20">
                <el-container style="margin-left: 10px; margin-right: 10px">
                    <el-header>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="12" style="font-size: 20px; padding: 5px 5px; text-align: left"
                                >{{ scheduleTitle }} <el-tag size="small" v-if="schedule_result.status == 2" type="success">已发布</el-tag>
                                <el-tag v-else-if="schedule_result.status == 1" type="warning">未发布</el-tag><el-tag v-else type="danger">已停用</el-tag></el-col
                            >
                            <el-col :span="12" style="text-align: right; padding-top: 8px">
                                <el-button-group v-if="schedule_result.status == 1">
                                    <el-button type="primary" size="small" :style="{ borderRadius:'4px' }" v-has-permission="editPermission" @click="save(1)">保存</el-button>
                                    <el-button type="primary" size="small" :style="{ borderRadius:'4px' }" v-has-permission="publishPermission" @click="save(2)">发布</el-button>
                                    <el-button type="primary" size="small" :style="{ borderRadius:'4px' }" v-has-permission="editPermission" @click="copyPreWeek()">{{copyTitle}}</el-button>
                                </el-button-group>
                                <el-button-group v-else-if="schedule_result.status == 2">
                                    <el-button type="primary" size="small" :style="{ borderRadius:'4px' }" v-has-permission="editPermission" @click="updateStatus(1)">重新编辑</el-button>
                                    <el-button type="danger" size="small" :style="{ borderRadius:'4px' }"  v-has-permission="publishPermission" @click="updateStatus(3)">停用</el-button>
                                </el-button-group>
                                <el-button-group v-else-if="schedule_result.status == 3">
                                    <el-button type="primary" size="small" :style="{ borderRadius:'4px' }" v-has-permission="editPermission" @click="updateStatus(1)">重新编辑</el-button>
                                    <el-button type="primary" size="small" :style="{ borderRadius:'4px' }" v-has-permission="editPermission" @click="copyPreWeek()">{{copyTitle}}</el-button>
                                </el-button-group>
                                <el-dropdown @command="exportInfo" v-has-permission="exportPermission">
                                    <el-button size="small">导出 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="CurrentPage">当前页</el-dropdown-item>
                                        <el-dropdown-item command="OtherPages">其它页</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-dropdown @command="printInfo" v-has-permission="printPermission">
                                    <el-button size="small">打印 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="CurrentPage">当前页</el-dropdown-item>
                                        <el-dropdown-item command="OtherPages">其它页</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </el-col>
                        </el-row>
                    </el-header>
                    <el-main>
                        <div class="calenda" style="height: 100%; width: 100%" v-if="scheduleSet_Type == 'shift'">
                            <el-table
                                :data="shiftTableData"
                                class="calendartable"
                                border
                                :cell-style="tableCellStyle"
                                @cell-click="handleCellClick"
                                @cell-mouse-enter="handleCellEnter"
                                @cell-mouse-leave="handleCellLeave"
                                :height="this.screenHeight2 - 325"
                            >
                                <el-table-column type="index" label="序号" align="center" width="40" header-align="center"> </el-table-column>
                                <el-table-column prop="dic_shift_name" label="班次" width="120" align="center" header-align="center">
                                    <div slot-scope="scope">
                                        <div>{{ scope.row.dic_shift_name }}</div>
                                    </div>
                                </el-table-column>
                                <el-table-column v-for="(col, index) in scheduleTimeSpan" :key="col" width="200" header-align="center">
                                    <template #header> {{ $moment(col).format(`MM月DD日`) }}<br />{{ $moment.weekdays($moment(col).day()) }} </template>
                                    <div class="item" slot-scope="scope" @click="active_item = [scope.$index, index + 2]" @dragenter="aaaa($event)" @dragover="bbbb" @dragleave="cccc">
                                        <draggable
                                            class="item__txt"
                                            style="position: relative"
                                            tag="div"
                                            v-model="scope.row[col]"
                                            v-bind="listUserDragOptions"
                                            @change="change($event, scope.row[col])"
                                        >
                                            <el-tag
                                                class="usertag"
                                                v-for="(user, ix) in scope.row[col]"
                                                :key="ix"
                                                :closable="schedule_result.status == 1"
                                                @close="handleClose(scope.row[col], user, scope.$index, index + 2)"
                                            >
                                                {{ user && user.worker_name }}
                                            </el-tag>
                                            <div v-if="!filter_readonly(index + 2, scope.$index) && schedule_result.status == 1">
                                                <i class="el-icon-circle-plus" style="font-size: 20px; position: absolute; bottom: 5px; right: 5px" @click="showSetAnesDoctor(scope.row[col])"></i>
                                            </div>
                                        </draggable>
                                    </div>
                                </el-table-column>

                            </el-table>
                        </div>
                        <div v-else>
                            <!-- xxxxxxx -->

                            <!-- <div v-if="issave">{{ save_schedule_result.result_details }}</div> -->
                            <el-table
                                :data="shiftTableData"
                                border
                                :cell-style="shiftTableCellStyle"
                                @row-contextmenu="rightClickIsOverTime"
                                :span-method="objectSpanMethod"
                                style="width: 100%"
                                :height="this.screenHeight2 - 325"
                            >
                                <el-table-column prop="ix_seq" label="序号" align="center" width="40" header-align="center"> </el-table-column>
                                <el-table-column prop="worker_name" label="姓名" width="120" align="center" header-align="center"></el-table-column>
                                <el-table-column prop="work_years" label="工作年限" width="120" align="center" header-align="center"></el-table-column>
                                <el-table-column prop="work_duty" label="职称" width="120" align="center" header-align="center"></el-table-column>
                                <el-table-column prop="work_scale" label="岗位/层级" width="120" align="center" header-align="center"></el-table-column>
                                <el-table-column v-for="col in scheduleTimeSpan" :prop="col" :key="col" width="120" header-align="center">
                                    <template #header> {{ $moment(col).format(`MM月DD日`) }}<br />{{ $moment.weekdays($moment(col).day()) }} </template>
                                    <div v-if="scope.row.worker_id!=0" slot-scope="scope" style="min-height: 40px; width: 100%">
                                        <div>
                                            <draggable
                                                class="item__txt"
                                                style="position: relative"
                                                tag="div"
                                                v-model="scope.row[col]"
                                                v-bind="listShiftDragOptions"
                                                @change="shiftDragChange($event, scope.row[col])"
                                            >
                                                <div style="min-height: 40px; width: 100%" class="ver-hori-center" @click="becomeEditMode(scope,col)" v-show="scope.row[col][0].enableEdit == undefined || scope.row[col][0].enableEdit == false">{{ scope.row[col][0].dic_shift_name }}</div>
                                                <el-select
                                                    v-show="scope.row[col][0].enableEdit == true"
                                                    @change="(value) => becomeDisableEditMode(scope,col,value)"
                                                    class="elSelect-Class"
                                                    filterable
                                                    clearable
                                                    placeholder=""
                                                    size="small"
                                                    v-model="scope.row[col][0].dic_shift_id"
                                                    :disabled="schedule_result.status !== 1"
                                                >
                                                    <el-option v-for="shift in schedule_sifts_copy" :key="shift.dic_shift_id" :label="shift.dic_shift_name" :value="shift.dic_shift_id">
                                                        <span style="float: left; padding-right: 20px">{{ shift.dic_shift_name }}</span>
                                                    </el-option>
                                                </el-select>
                                            </draggable>
                                            <!-- :disabled="!schedule_result.status == 1" -->
                                            <!-- <el-select
                                                class="elSelect-Class"
                                                v-model="scope.row[col]"
                                                :value-key="scope.row[col]"
                                                filterable
                                                size="small"
                                                @change="selectedChange(scope.row, col, scope.row[col])"
                                            >
                                                <el-option v-for="shift in schedule_sifts" :key="shift.dic_shift_id" :label="shift.dic_shift_name" :value="shift.dic_shift_id">
                                                    <span style="float: left; padding-right: 20px">{{ shift.dic_shift_name }}</span>
                                                </el-option>
                                            </el-select> -->
                                            <!-- <div>{{ scope.row[col][0].is_link_annual_leave }}</div> -->
                                            <div
                                                v-show="scope.row[col][0].is_overtime || scope.row[col][0].is_link_annual_leave"
                                                @click="showIsOverTime(scope.row, scope.row[col][0], col)"
                                                style="
                                                    position: absolute;
                                                    bottom: 0px;
                                                    right: 0px;
                                                    border-top: 8px solid transparent;
                                                    border-left: 8px solid transparent;
                                                    border-right: 8px solid black;
                                                    border-bottom: 8px solid black;
                                                    z-index: 99;
                                                "
                                            ></div>
                                        </div>

                                        <!-- <div v-else> -->
                                        <!-- <div> -->
                                        <!-- //鼠标离开被就改为黄色
                                                鼠标悬浮去掉背景 -->
                                        <!-- <div>{{ scope.row[col] }}</div>
                                                <el-select class="elSelect-Class" v-model="scope.row[col]" :key="scope.row[col]" filterable size="small" @change="change">
                                                    <el-option v-for="shift in schedule_sifts" :key="shift.dic_shift_id" :label="shift.dic_shift_name" :value="shift.dic_shift_id">
                                                        <span style="float: left; padding-right: 20px">{{ shift.dic_shift_name }}</span>
                                                    </el-option>
                                                </el-select>
                                            </div>
                                            <div
                                                style="
                                                    position: absolute;
                                                    bottom: 0px;
                                                    right: 0px;
                                                    border-top: 5px solid transparent;
                                                    border-left: 5px solid transparent;
                                                    border-right: 5px solid black;
                                                    border-bottom: 5px solid black;
                                                    z-index: 99;
                                                "
                                            ></div> -->
                                        <!-- </div> -->
                                        <!-- <draggable
                                            v-if="!filter_readonly(index + 2, scope.$index)"
                                            class="list-group"
                                            tag="div"
                                            v-model="scope.row[col]"
                                            v-bind="listUserDragOptions"
                                            @change="change($event, { userId: scope.row.id })"
                                        >
                                            <el-select v-for="shift in scope.row[col]" v-model="shift.dic_shift_id" :key="shift.dic_shift_id" filterable size="small" class="select width-p100">
                                                <el-option v-for="shift in schedule_sifts" :key="shift.dic_shift_id" :label="shift.dic_shift_name" :value="shift.dic_shift_id">
                                                    <span style="float: left; padding-right: 20px">{{ shift.dic_shift_name }}</span>
                                                </el-option>
                                            </el-select>
                                        </draggable>
                                        <draggable v-else class="list-group" tag="div" v-model="scope.row[col]" v-bind="listUserDragOptions" @change="change($event, { userId: scope.row.id })">
                                            <el-select v-for="shift in scope.row[col]" v-model="shift.dic_shift_id" :key="shift.dic_shift_id" filterable size="small" class="select width-p100">
                                                <el-option v-for="shift in schedule_sifts" :key="shift.dic_shift_id" :label="shift.dic_shift_name" :value="shift.dic_shift_id">
                                                    <span style="float: left; padding-right: 20px">{{ shift.dic_shift_name }}</span>
                                                </el-option>
                                            </el-select>
                                        </draggable> -->
                                    </div>
                                </el-table-column>
                                <el-table-column prop="dic_shift_times" width="120" align="center" header-align="center">
                                    <template #header>{{viewType=='week'?'本周上班时长':(viewType=='day'?'本日上班时长':'本月上班时长')}}</template>
                                    <div v-if="scope.row.worker_id!=0" slot-scope="scope">
                                        {{scope.row.dic_shift_times}}
                                    </div>
                                    </el-table-column>
                            </el-table>
                        </div>
                    </el-main>
                    <el-footer>
                        <el-input type="textarea" v-model="schedule_result.remark"></el-input>
                    </el-footer>
                </el-container>
            </el-col>
        </el-row>
        <el-dialog :title="publishRecord.title" :close-on-click-modal="false" :visible.sync="publishRecord.dialogFormVisible" class="table-h560" width="60%">
            <el-row>
                <el-col :span="6">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
            </el-row>
            <ListView :datalist="publishRecord.data" :columns="publishRecord.columns" :buttons="publishRecord.buttons" @extrabutton-click="ExtraButtonClick"></ListView>
            <span slot="footer" class="dialog-footer">
                <el-button @click="publishRecord.dialogFormVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <form-dialog
            :title="setIsOverTime.title"
            :data="setIsOverTime.data"
            width="30%"
            :visible.sync="setIsOverTime.dialogFormVisible"
            :columns="setIsOverTime.columns"
            @confirm="setIsOverTimeSave"
        ></form-dialog>
        <el-dialog :visible.sync="setAnesDoctor.dialogFormVisible" :close-on-click-modal="false" width="20%" class="setworkerdialog">
            <!-- <div style="height: 150px">
                <el-select multiple multiple-limit="10" filterable remote reserve-keyword collapse-tags class="remotemultiselect1" ref="remotemultiselectRef">
                    <el-option v-for="op in []" :key="op.value" :label="op.label" :value="op" :disabled="op.disabled">
                        <span style="float: left; padding-right: 10px">{{ op.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 10px; width: 170px; overflow: hidden">{{ op.code }}</span>
                    </el-option>
                </el-select>
            </div> -->
            <div style="margin: 20px 10px">
                <el-select multiple v-model="setAnesDoctor.data" filterable :clearable="false" class="remotemultiselect" ref="remotemultiselectRef">
                    <el-option-group v-for="group in schedule_userGroup" :key="group.id" :label="group.name">
                        <el-option v-for="item in group.users" :key="item.worker_id" :label="item.worker_name" :value="item.worker_id" :disabled="item.worker_disabled">
                            <span style="float: left; padding-right: 10px">{{ item.worker_name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 10px; width: 170px; overflow: hidden">{{ item.worker_section_name }}</span>
                        </el-option>
                    </el-option-group>
                    <!-- <el-option v-for="op in workeroptions" :key="op.value" :label="op.label" :value="op" :disabled="op.disabled">
                        <span style="float: left; padding-right: 10px">{{ op.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 10px; width: 170px; overflow: hidden">{{ op.code }}</span>
                    </el-option> -->
                </el-select>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="setAnesDoctor.dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="setDoctorConfirm">确 定</el-button>
            </div>
        </el-dialog>
        <cus-dialog :title="exportForm.title" :visible.sync="exportForm.dialogFormVisible" width="30%" @confirm="exportByTime()">
            <div class="margin10 margin-none-h align-left">
                <item-input type="daterange" v-model="exportForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
        <cus-dialog :title="printForm.title" :visible.sync="printForm.dialogFormVisible" width="30%" @confirm="printByTime()">
            <div class="margin10 margin-none-h align-left">
                <item-input type="daterange" v-model="printForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
export default {
    name: `ScheduleSetup`,
    props: {},
    components: { draggable },
    data() {
        return {
            title: `排班设置`,
            token: this.$route.query.token,
            activeScheduleId: 0,
            activeSchedule: {},
            scheduleSet_Type: `userGroup`, // 默认按人员排班
            viewType: `week`, // 默认显示周视图
            active_item: [],
            onPicker: {
                firstDayOfWeek: 1
            },
            dateValue: this.$moment().format(`YYYY/MM/DD`),
            year: ``,
            month: ``,
            week: ``,
            day: ``,
            start: ``, // 起始日期
            end: ``, // 截止日期
            rdate: [
                this.$moment()
                    .add(-7, `days`)
                    .format(`YYYY/MM/DD`),
                this.$moment().format(`YYYY/MM/DD`)

            ],
            schedule_userGroup: [],
            schedule_sifts: [],
            schedule_sifts_copy: [],
            schedule_result: {},
            issave: false,
            scheduleTimeSpan: [
            ],
            shiftTableData: [],
            save_schedule_result: null,
            printForm: {
                dialogFormVisible: false,
                from_to: [],
                day_doc_code: `SPDay001`,
                week_doc_code: `SPWeek001`,
                month_doc_code: `SPMonth001`,
                title: `日期区间`
            },
            exportForm: {
                dialogFormVisible: false,
                from_to: [],
                title: `日期区间`
            },
            publishRecord: {
                title: `发布记录`,
                data: [],
                columns: [{
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_ward`,
                    label: `手术区域`,
                    isListable: true,
                    width: 80
                },

                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `start_to_end`,
                    label: `排班日期`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `logtext`,
                    label: `类型`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `发布人`,
                    isListable: true
                },

                {
                    type: `datetime`,
                    prop: `createdt`,
                    label: `发布时间`,
                    isListable: true
                }
                ],
                dialogFormVisible: false
            },
            setAnesDoctor: {
                title: ``,
                data: [],
                dateusers: [],
                dialogFormVisible: false
            },
            setIsOverTime: {
                title: `设置`,
                data: {},
                columns: [{
                    type: `radio`,
                    prop: `is_overtime`,
                    label: `是否关联加班`,
                    options: [
                        { value: true, label: `是` },
                        { value: false, label: `否` }
                    ],
                    colspan: 24,
                    default: true,
                    change: (that, { row, index }) => {
                        if (row.is_overtime) {
                            console.log(`rrrrrr`, row)
                        } else {
                            row.over_long_time = null
                            console.log(`bbbbb`, row)
                        }
                    }
                },
                {
                    type: `float`,
                    prop: `over_long_time`,
                    label: `加班时长(小时)`,
                    isCreatable: true,
                    colspan: 12,
                    isEditable: false,
                    readonly: (that, { row }) => {
                        return !row.is_overtime
                    }
                },
                {
                    type: `radio`,
                    prop: `is_link_annual_leave`,
                    label: `是否关联年休假`,
                    options: [
                        { value: true, label: `是` },
                        { value: false, label: `否` }
                    ],
                    colspan: 24,
                    default: true
                }],
                dialogFormVisible: false
            },
            loading: false,
            options: [],
            schedules: [],
            editPermission: `schedule_setup:edit`,
            publishPermission: `schedule_setup:publish`,
            exportPermission: `schedule_setup:export`,
            printPermission: `schedule_setup:print`,
            workerList: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        // 设置视图显示模式,默认显示周视图
        this.changeDatePickerSetScheduleTimeSpan(this.dateValue, 0)
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.loadCurrentUserSchedules().then((activeScheduleId) => {
                this.loadActiveScheduleUserGroupsAndShifts(activeScheduleId).then((sifts) => {
                    this.loadScheduleResultsAndCreateShiftTable()
                })
            })
        })
    },
    mounted() {
    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`,
            `permissions`,
            `sysuser/workers_by_duty`,
            `currentUser`,
            `sysuser/workers`,
            `active_ward`, `sys_enums`, `section_auth`, `ward_auth`]),
        userDragOption() {
            return {
                animation: 0,
                group: { name: `user`, put: false, pull: `clone` },
                disabled: false,
                ghostClass: `ghost`,
                sort: false,
                filter: `.undraggable`
            }
        },
        listUserDragOptions() {
            return {
                animation: 0,
                group: { name: `user`, pull: true, put: this.checkPut },
                // group: `user`,
                disabled: false,
                ghostClass: `ghost`,
                sort: true
            }
        },
        shiftDragOption() {
            return {
                animation: 0,
                group: { name: `shift`, put: false, pull: `clone` },
                disabled: false,
                ghostClass: `ghost`,
                sort: false,
                filter: `.undraggable`
            }
        },
        listShiftDragOptions() {
            return {
                animation: 0,
                group: { name: `shift`, pull: false, put: this.checkPut },
                disabled: false,
                ghostClass: `ghost`,
                sort: false
            }
        },
        screenHeight2() {
            return this.screenHeight
        },
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        openeds() {
            return this.schedule_userGroup.map(i => i.id.toString())
        },
        scheduleTitle() {
            let endstr = ``
            if (this.viewType == `day`) {
                endstr = `[${this.$moment(this.dateValue).format(`YYYY-MM-DD`)}]`
            }
            if (this.viewType == `month`) {
                endstr = `[${this.$moment(this.dateValue).format(`YYYY-MM`)}]`
            }
            return this.activeSchedule && this.activeSchedule.schedule_title + endstr
        },
        copyTitle() {
            let endstr = ``
            if (this.viewType == `day`) {
                endstr = `复制上一天`
            } else if (this.viewType == `month`) {
                endstr = `复制上一月`
            } else {
                endstr = `复制上一周`
            }
            return endstr
        }

    },
    methods: {
        becomeEditMode(scope, col) {
            this.$set(scope.row[col][0], `enableEdit`, true)
        },
        becomeDisableEditMode(scope, col, value) {
            if (!value) return
            let data = this.schedule_sifts_copy.find(item => item.dic_shift_id == value)
            Object.keys(data).forEach(key => {
                scope.row[col][0][key] = data[key]
            })
            scope.row[col][0].enableEdit = false
            console.log(scope.row[col][0])
        },
        checkPut(v) {
            let that = this
            if (that.schedule_result.status != 1) {
                return false
            } else {
                return true
            }
        },
        showIsOverTime(row, col, date) {
            let that = this
            if (that.schedule_result.status != 1) {
                return
            }
            if (col.dic_shift_id && col.dic_shift_id != null && col.dic_shift_id != ``) {
                // that.setIsOverTime.data = col
                that.setIsOverTime.data = {
                    dic_shift_id: col.dic_shift_id,
                    worker_id: row.worker_id,
                    schedule_date: date,
                    is_overtime: col.is_overtime || false,
                    over_long_time: col.over_long_time || null,
                    is_link_annual_leave: col.is_link_annual_leave || false
                }
                that.setIsOverTime.dialogFormVisible = true
            }
        },
        rightClickIsOverTime(row, column, event) {
            let that = this
            event.preventDefault()// 阻止鼠标右键默认行为
            // event.stopPropagation()
            // event.preventDefault()
            let colname = column.property

            if (that.scheduleTimeSpan.findIndex(date => date === colname) > -1 && row[colname][0]) {
                let seletShift = row[colname][0]
                if (seletShift.dic_shift_id && seletShift.dic_shift_id != null && seletShift.dic_shift_id != ``) {
                    // that.setIsOverTime.data = seletShift
                    that.setIsOverTime.data = {
                        dic_shift_id: seletShift.dic_shift_id,
                        worker_id: row.worker_id,
                        schedule_date: colname,
                        is_overtime: seletShift.is_overtime || false,
                        over_long_time: seletShift.over_long_time || null,
                        is_link_annual_leave: seletShift.is_link_annual_leave || false
                    }
                    that.setIsOverTime.dialogFormVisible = true
                }
            }
        },
        setIsOverTimeSave(data) {
            let that = this
            let tableuser = _.find(that.shiftTableData, user => {
                return user.worker_id == data.worker_id
            })
            if (tableuser != null && tableuser[data.schedule_date] && tableuser[data.schedule_date][0]) {
                let shift = tableuser[data.schedule_date][0]
                if (shift.dic_shift_id == data.dic_shift_id) {
                    shift.is_overtime = data.is_overtime
                    shift.over_long_time = data.over_long_time
                    shift.is_link_annual_leave = data.is_link_annual_leave
                }
            }
            that.setIsOverTime.dialogFormVisible = false
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.worker_id === 0) {
                if (columnIndex === 1) {
                    if (this.viewType == `day`) {
                        return [1, 6]
                    }
                    if (this.viewType == `week`) {
                        return [1, 12]
                    }
                    if (this.viewType == `month`) {
                        return [1, 35]
                    }
                } else {
                    return [1, 1]
                }
            }
        },
        setDoctorConfirm() {
            this.setAnesDoctor.dialogFormVisible = false
            if (this.setAnesDoctor.data && this.setAnesDoctor.data.length > 0) {
                this.setAnesDoctor.data.forEach((item, index) => {
                    let mc = _.find(this.setAnesDoctor.dateusers, x => x.worker_id == item)
                    if (mc) {
                    } else {
                        let info = _.find(this.workerList, x => x.worker_id == item)
                        if (info) {
                            let worker = {
                                worker_name: info.worker_name,
                                worker_id: info.worker_id,
                                worker_code: info.worker_code
                            }
                            this.setAnesDoctor.dateusers.push(worker)
                        }
                    }
                })
            }
        },
        showSetAnesDoctor(colusers) {
            this.setAnesDoctor.dialogFormVisible = true
            this.setAnesDoctor.dateusers = colusers
            this.setAnesDoctor.data = []
        },
        tableCellStyle({ row, column, rowIndex, columnIndex }) {
            let that = this
            let cls = column.property
            let style = ``
            if (cls == `dic_shift_name`) {
                let shift = that.getDicShiftById(row.dic_shift_id)
                if (shift) {
                    style = {
                        "background": shift.back_color,
                        "color": shift.color
                    }
                }
            }

            if (cls !== `dic_shift_name` && cls !== `dic_shift_id` && cls !== `index` && that.active_item[0] == rowIndex && that.active_item[1] == columnIndex) {
                style = {
                    "background": `#ffffff`,
                    "border": `2px solid #0C9781`
                }
            }
            return style
        },
        shiftTableCellStyle({ row, column, rowIndex, columnIndex }) {
            let that = this
            let colname = column.property
            let style = ``
            if (row.worker_id != 0 && that.scheduleTimeSpan.findIndex(date => date === colname) > -1 && row[colname][0]) {
                let shiftId = row[colname][0].dic_shift_id
                if (shiftId && shiftId != null && shiftId != ``) {
                    let shift = that.getDicShiftById(shiftId)
                    if (shift) {
                        style = {
                            "background": shift.back_color,
                            "color": shift.color
                        }
                    }
                }
            }
            if (row.worker_id == 0) {
                style = {
                    "font-size": 22,
                    "font-weight": `bold`,
                    "height": `50px`
                }
            }
            return style
        },
        ddddd(a, e) {
            console.log(`dddd`, a, e)
        },
        aaaa(e) {
            // this.isDrag = true
            console.log(`enterenterenterenterenterenter`)
        },
        bbbb(e) { console.log(`bbbb(e){`) },
        cccc(e) { this.isDrag = false },

        ExtraButtonClick(target) {
            let e = {}
            ;({ index: e.index, row: e.row } = target)
            if (this[target.emit]) {
                this[target.emit](e)
            } else {
                this.$emit(target.emit, e)
            }
        },
        // 上一日，下一日,上一周，下一周,上一月，下一月
        addDate(prevOrNext) {
            let that = this
            if (prevOrNext == 0) {
                this.dateValue = that.$moment()
            }
            that.changeDatePickerSetScheduleTimeSpan(that.dateValue, prevOrNext)
        },
        changeDatePickerSetScheduleTimeSpan(date, prevOrNext = 0) {
            let that = this
            that.scheduleTimeSpan = []
            if (that.viewType == `week`) {
                if (prevOrNext == 0) {
                    let weekOfDay = that.$moment(this.dateValue).format(`E`)
                    let firstday = that
                        .$moment(this.dateValue)
                        .subtract(weekOfDay - 1, `days`)
                        .format(`YYYY-MM-DD`)
                    let endday = that
                        .$moment(this.dateValue)
                        .subtract(weekOfDay - 7, `days`)
                        .format(`YYYY-MM-DD`)
                    this.dateValue = firstday
                    this.start = firstday
                    this.end = endday
                } else {
                    let prev = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `week`)
                        .startOf(`week`)
                        .format(`YYYY-MM-DD`)
                    let next = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `week`)
                        .endOf(`week`)
                        .format(`YYYY-MM-DD`)
                    this.dateValue = prev

                    this.start = prev
                    this.end = next
                }
                this.year = that.$moment(this.dateValue).year()
                this.month = that.$moment(this.dateValue).month() + 1
                this.week = that.$moment(this.dateValue).week()
                this.day = that.$moment(this.dateValue).format(`YYYY-MM-DD`)

                this.scheduleTimeSpan = []
                for (let i = 0; i < 7; i++) {
                    let day = that.$moment(this.start).add(i, `d`).format(`YYYY-MM-DD`)
                    that.scheduleTimeSpan.push(day)
                }
            } else if (that.viewType == `month`) {
                let daysInMonth = 0
                if (prevOrNext == 0) {
                    daysInMonth = that.$moment(this.dateValue).daysInMonth()
                } else {
                    let prev = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `month`)
                    this.dateValue = prev
                    daysInMonth = that.$moment(prev).daysInMonth()
                }
                this.week = that.$moment(this.dateValue).week()
                this.month = that.$moment(this.dateValue).month() + 1
                this.year = that.$moment(this.dateValue).year()
                this.day = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                this.start = that
                    .$moment(this.dateValue).startOf(`month`).format(`YYYY-MM-DD`)
                this.end = that
                    .$moment(this.dateValue).endOf(`month`).format(`YYYY-MM-DD`)
                for (let i = 1; i <= daysInMonth; i++) {
                    that.scheduleTimeSpan.push(that.$moment(this.dateValue).date(i).format(`YYYY-MM-DD`))
                }
            } else {
                if (prevOrNext !== 0) {
                    let prev = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `day`)
                        .format(`YYYY-MM-DD`)
                    this.dateValue = prev
                }
                this.year = that.$moment(this.dateValue).year()
                this.month = that.$moment(this.dateValue).month() + 1
                this.week = that.$moment(this.dateValue).week()
                this.day = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                this.start = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                this.end = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                that.scheduleTimeSpan.push(this.day)
            }
        },
        loadCurrentUserSchedules() {
            let that = this
            return new Promise(resolve => {
                let req = that.myaxios.get(`/api/AcisSystem/DicSchedule/GetScheduleByUserId?userId=${(this.currentUser && this.currentUser.id) || 0}&type=2`)
                req.then(data => {
                    if (data && data.length > 0) {
                        data.map(i => { i.id = String(i.id) })
                        that.schedules = data
                        that.activeScheduleId = that.schedules[0].id
                        that.activeSchedule = that.schedules[0]
                    }
                    resolve(that.activeScheduleId)
                })
            })
        },
        loadActiveScheduleUserGroupsAndShifts(activeScheduleId) {
            let that = this
            that.schedule_userGroup = []
            that.schedule_sifts = []
            that.schedule_sifts_copy = []
            return new Promise(resolve => {
                // 获取排班表设置的用户组
                let req = this.myaxios.get(`/api/AcisSystem/ShiftUserGroup/GetUserGroupByScheduleId?scheduleId=${activeScheduleId}`)
                // 获取排班表设置的班次
                let req1 = this.myaxios.get(`api/AcisSystem/DicShift/GetShiftByScheduleId?scheduleId=${activeScheduleId}`)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    that.schedule_userGroup = data
                    that.workerList = []
                    _.forEach(this.schedule_userGroup, item => {
                        item.users && _.forEach(item.users, user => {
                            if (user.worker_id > 0) {
                                that.workerList.push({
                                    worker_name: user.worker_name,
                                    worker_id: user.worker_id,
                                    worker_code: user.worker_section_name
                                })
                            }
                        })
                    })
                    that.schedule_sifts = data1
                    that.schedule_sifts_copy = _.cloneDeep(data1)
                    resolve(that.schedule_sifts)
                })
            })
        },
        loadScheduleResultsAndCreateShiftTable() {
            let that = this
            that.shiftTableData = []
            that.loadScheduleResults().then((results) => {
                if (that.scheduleSet_Type == `shift`) {
                    this.createShiftTableData(results)
                } else {
                    this.createUserTableData(results)
                }
            })
        },
        loadScheduleResults() {
            let that = this
            that.active_item = []
            return new Promise(resolve => {
                let type = this.viewType == `day` ? 1 : (this.viewType == `week` ? 2 : 3)
                let url = `/api/AcisSystem/ScheduleResult/GetScheduleResult?dic_schedule_id=${that.activeScheduleId}&startDT=${that.start}&endDT=${that.end}&type=${type}`

                that.myaxios.get(url).then(data => {
                    if (data != null) {
                        that.schedule_result = data
                        if (that.schedule_result.id == 0) {
                            that.schedule_result = {
                                name: ``,
                                dic_schedule_id: that.activeScheduleId,
                                year: this.year,
                                month: this.month,
                                week: this.week,
                                start_dt: this.start,
                                schedule_dt: that.$moment(that.dateValue).format(`YYYY-MM-DD`),
                                end_dt: this.end,
                                type: type,
                                status: 1,
                                status_name: `未发布`,
                                remark: that.activeSchedule.remark
                            }
                            that.schedule_result.result_details = data.result_details
                        }
                    } else {
                        that.schedule_result = { id: 0,
                            name: ``,
                            dic_schedule_id: that.activeScheduleId,
                            year: this.year,
                            month: this.month,
                            week: this.week,
                            start_dt: this.start,
                            end_dt: this.end,
                            type: type,
                            status: 1,
                            status_name: `未发布`,
                            remark: that.activeSchedule.remark,
                            result_details: [] }
                    }

                    resolve(that.schedule_result)
                })
            })
        },
        createShiftTableData(results) {
            let that = this
            that.shiftTableData = []
            let row = {
                'dic_shift_id': 0,
                'dic_shift_name': ``

            }
            let resultDetails = results.result_details

            // 创建table rows
            if (that.schedule_sifts && that.schedule_sifts.length > 0) {
                let sifts = that.schedule_sifts

                for (let i = 0; i < sifts.length; i++) {
                    let shiftusers = _.filter(resultDetails, (d) => {
                        return d.dic_shift_id === sifts[i].dic_shift_id
                    }) || []

                    var newrow = Object.assign({}, row)
                    newrow[`dic_shift_id`] = sifts[i].dic_shift_id
                    newrow[`dic_shift_name`] = sifts[i].dic_shift_name
                    newrow[`is_link_annual_leave`] = sifts[i].is_link_annual_leave
                    newrow[`is_overtime`] = sifts[i].is_overtime

                    for (let index = 0; index < that.scheduleTimeSpan.length; index++) {
                        let shiftDateUsers = _.filter(shiftusers, (d) => {
                            return (d.schedule_date && that.$moment(d.schedule_date).format(`YYYY-MM-DD`) === that.scheduleTimeSpan[index])
                        })
                        if (shiftDateUsers && shiftDateUsers.length > 0) {
                            newrow[that.scheduleTimeSpan[index]] = shiftDateUsers
                        } else {
                            newrow[that.scheduleTimeSpan[index]] = []
                        }
                    }
                    that.shiftTableData.push(newrow)
                }
            }
        },
        createUserTableData(results) {
            let that = this
            that.shiftTableData = []
            let row = {
                'ix_seq': null,
                'worker_id': 0,
                'worker_name': ``,
                'work_years': ``,
                'work_duty': ``,
                'work_scale': ``
            }
            let resultDetails = results.result_details
            // 创建table rows  xxxx
            let workers = that.getWorkers(that.schedule_userGroup)
            if (workers && workers.length > 0) {
                for (let i = 0; i < workers.length; i++) {
                    // 这里最好按>本周开始且<本周结束过滤一下
                    let workerResults = _.filter(resultDetails, (d) => {
                        return d.worker_id === workers[i].worker_id
                    }) || []

                    var newrow = Object.assign({}, row)
                    newrow[`ix_seq`] = workers[i].ix_seq
                    newrow[`worker_id`] = workers[i].worker_id
                    newrow[`worker_name`] = workers[i].worker_name
                    newrow[`work_years`] = workers[i].work_years
                    newrow[`work_duty`] = workers[i].work_duty
                    newrow[`work_scale`] = workers[i].work_scale
                    newrow[`enableEdit`] = false

                    for (let index = 0; index < that.scheduleTimeSpan.length; index++) {
                        let userDateShifts = _.filter(workerResults, (d) => {
                            return (d.schedule_date && that.$moment(d.schedule_date).format(`YYYY-MM-DD`) === that.scheduleTimeSpan[index])
                        })
                        if (userDateShifts && userDateShifts.length > 0) {
                            newrow[that.scheduleTimeSpan[index]] = userDateShifts
                            // newrow[that.scheduleTimeSpan[index]] = userDateShifts[0].dic_shift_id
                        } else {
                            newrow[that.scheduleTimeSpan[index]] = [{ dic_shift_id: null, is_overtime: null, over_long_time: null, is_link_annual_leave: null, enableEdit: false }]
                        }
                        let sumWorkerMinutes = _.sumBy(workerResults,
                            d => d.dic_shift_times
                        )
                        newrow[`dic_shift_times`] = that.getTimes(sumWorkerMinutes)
                    }
                    that.shiftTableData.push(newrow)
                }
            }
        },

        getWorkers() {
            let that = this
            let workers = []
            _.forEach(that.schedule_userGroup, row => {
                let workergroup = {
                    ix_seq: null,
                    worker_id: 0,
                    count: 0,
                    worker_code: ``,
                    worker_name: row.name,
                    work_duty: null,
                    work_scale: null,
                    work_years: null
                }
                workers.push(workergroup)
                for (let i = 0; i < row.users.length; i++) {
                    let worker = {
                        ix_seq: i + 1,
                        worker_id: row.users[i].worker_id,
                        count: 0,
                        worker_code: ``,
                        worker_name: row.users[i].worker_name,
                        work_duty: row.users[i].enum_worker_dutyname,
                        work_scale: row.users[i].enum_post_name + `/` + row.users[i].enum_level_name,
                        work_years: that.getWorkYears(row.users[i].entry_time)
                    }
                    workers.push(worker)
                }
            })

            return workers
        },
        getTimes(minutes) {
            let that = this
            let minuteTitle = that.$moment().utc().startOf(`day`).add(minutes, `minutes`).format(`H小时mm`).replace(`00`, ``)
            return minuteTitle
        },
        getWorkYears(entryTime) {
            if (!entryTime) {
                return ``
            } else {
                let duration = this.$moment().diff(this.$moment(entryTime), `years`)
                if (duration < 1) {
                    let durationMonths = this.$moment().diff(this.$moment(entryTime), `months`)
                    return durationMonths + `月`
                } else {
                    return this.$moment().diff(this.$moment(entryTime), `years`) + `年`
                }
            }
        },
        /** 鼠标移入cell */
        handleCellEnter(row, column, cell, event) {
            // let name = column.property
            // console.log(`qqqqqqq`, name)
            // cell.querySelector(`.item__txt`).classList.add(`item__txt--hover`)
        },
        /** 鼠标移出cell */
        handleCellLeave(row, column, cell, event) {
            // let property = column.property
            // // console.log(`jjjjjjj`, property)
            // cell.querySelector(`.item__txt`).classList.remove(`item__txt--hover`)
            // cell.querySelector(`.item__txt`).classList.remove(`item__txt--click`)
        },
        /** 点击cell */
        handleCellClick(row, column, cell, event) {
            // console.log(`eeeeeeeeeeeeeee`, row, column, cell, event)
            // let eleActive = cell.querySelector(`.item__txt`)
            // if (eleActive) {
            //     eleActive.classList.add(`item__txt--click`)
            // }
        },
        change($event, users) {
            if (!$event) return

            let worker = $event.added.element
            let user = _.filter(users, op => {
                return op.worker_id == worker.worker_id
            })
            if (user.length >= 2) {
                this.$message.warning(`该员工当前班次已有排班!`)
                users.splice(users.indexOf(user), 1)
            }
        },
        shiftDragChange($event, shifts) {
            if (!$event.added) return
            let shift = $event.added.element

            let addshift = _.filter(shifts, op => {
                return op.dic_shift_id == shift.dic_shift_id
            })
            if (addshift.length >= 2) {
                this.$message.warning(`已安排相同班次!`)
                shifts.splice(shifts.indexOf(shift), 1)
                return
            }
            let shiftIndex = $event.added.newIndex
            if (shiftIndex == 0) {
                if (shifts && shifts.length > 0 && shifts[0]) {
                    shifts[0].dic_shift_id = shift.dic_shift_id
                    shifts[0].id = shift.id
                    shifts[0].dic_shift_name = shift.dic_shift_name
                    shifts[0].back_color = shift.back_color
                    shifts[0].color = shift.color
                    shifts[0].is_link_annual_leave = shift.is_link_annual_leave
                    shifts[0].is_overtime = shift.is_overtime
                }
            } else {
                shifts.splice(shiftIndex, 1)
                shifts.unshift(shift)
            }
            if (shifts.length >= 2) {
                shifts.pop()
            }
        },
        handleClose(rowusers, user, rowIndex, colIndex) {
            rowusers.splice(rowusers.indexOf(user), 1)
            this.active_item = [rowIndex, colIndex]
        },
        filter_readonly(column, row) {
            if (this.active_item[0] == row && this.active_item[1] == column) {
                return false
            }
            return true
        },
        save(publish) {
            let that = this
            return new Promise(resolve => {
                let saveResultDetailsRows = []
                let isAllSetup = true
                if (that.scheduleSet_Type == `shift`) {
                    for (let i = 0; i < that.shiftTableData.length; i++) {
                        for (let j = 0; j < that.scheduleTimeSpan.length; j++) {
                            var dayUsers = that.shiftTableData[i][that.scheduleTimeSpan[j]]
                            if (dayUsers && dayUsers.length > 0) {
                                for (let k = 0; k < dayUsers.length; k++) {
                                    let row = {
                                        biz_schedule_result_id: that.schedule_result.id,
                                        dic_schedule_id: that.schedule_result.dic_schedule_id,
                                        dic_shift_id: that.shiftTableData[i].dic_shift_id,
                                        dic_shift_name: that.shiftTableData[i].dic_shift_name,
                                        worker_code: dayUsers[k].worker_code,
                                        worker_id: dayUsers[k].worker_id,
                                        worker_name: dayUsers[k].worker_name,
                                        schedule_date: that.scheduleTimeSpan[j],
                                        is_overtime: that.shiftTableData[i].is_overtime,
                                        is_link_annual_leave: that.shiftTableData[i].is_link_annual_leave
                                    }
                                    saveResultDetailsRows.push(row)
                                }
                            } else {
                                isAllSetup = false
                            }
                        }
                    }
                } else {
                    let rows = _.filter(that.shiftTableData, (d) => {
                        return (d.worker_id != 0) // 过滤掉组
                    })

                    for (let i = 0; i < rows.length; i++) {
                        for (let j = 0; j < that.scheduleTimeSpan.length; j++) {
                            var dicShift = rows[i][that.scheduleTimeSpan[j]][0]
                            if (dicShift != null && dicShift.dic_shift_id != null && dicShift.dic_shift_id != ``) {
                                let row = {
                                    biz_schedule_result_id: that.schedule_result.id,
                                    dic_schedule_id: that.schedule_result.dic_schedule_id,
                                    dic_shift_id: dicShift.dic_shift_id,
                                    dic_shift_name: that.getDicShiftName(dicShift.dic_shift_id),
                                    worker_code: rows[i].worker_code,
                                    worker_id: rows[i].worker_id,
                                    worker_name: rows[i].worker_name,
                                    schedule_date: that.scheduleTimeSpan[j],
                                    is_overtime: dicShift.is_overtime,
                                    over_long_time: dicShift.over_long_time,
                                    is_link_annual_leave: dicShift.is_link_annual_leave

                                }
                                saveResultDetailsRows.push(row)
                            } else {
                                isAllSetup = false
                            }
                        }
                    }
                }

                that.save_schedule_result = that.schedule_result
                that.save_schedule_result.year = this.year
                that.save_schedule_result.week = this.week
                that.save_schedule_result.start_dt = this.start
                that.save_schedule_result.end_dt = this.end
                that.save_schedule_result.type = (this.viewType == `day` ? 1 : (this.viewType == `week` ? 2 : 3))

                that.save_schedule_result.result_details = saveResultDetailsRows
                if (that.save_schedule_result.result_details && that.save_schedule_result.result_details.length == 0) {
                    that.$message.error(`请添加排班记录`)
                    return
                }

                if (publish == 2 && !isAllSetup) {
                    return that.$confirm(`排班表中还有未编辑的部分,请确保所有内容都已填写完整后再发布`, `确认提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    }).then(() => {
                        that.saveDetail(publish, that.save_schedule_result)
                    }).catch(e => {

                    })
                }

                that.issave = true
                that.saveDetail(publish, that.save_schedule_result)
                resolve()
            })
        },
        saveDetail(publish, result) {
            let that = this
            let url = `/api/AcisSystem/ScheduleResult/SaveScheduleResultDetail?publish=${publish}`
            var reps = this.myaxios.post(url, result)
            reps.then(data => {
                this.loadScheduleResultsAndCreateShiftTable()
                that.$message.success(`${publish == 2 ? `发布成功` : `信息保存成功`}`)
            })
        },
        updateStatus(publish) {
            let that = this
            return new Promise(resolve => {
                if (that.schedule_result) {
                    that.schedule_result.status = publish
                }
                let url = `/api/AcisSystem/ScheduleResult/Put`
                var reps = this.myaxios.put(url, that.schedule_result)
                reps.then(data => {
                    this.loadScheduleResultsAndCreateShiftTable()
                    resolve()
                })
            })
        },
        exportInfo(command) {
            let that = this
            // 当前页
            if (command == `CurrentPage`) {
                let from = null
                let to = null
                let type = 0
                if (that.viewType == `day`) {
                    from = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
                    to = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
                    type = 1
                }
                if (that.viewType == `week` || that.viewType == `month`) {
                    from = this.$moment(that.start).format(`YYYY-MM-DD`)
                    to = this.$moment(that.end).format(`YYYY-MM-DD`)
                    type = that.viewType == `week` ? 2 : 3
                }

                this.myaxios.get(`/api/AcisSystem/ScheduleResult/GetScheduleResultForExport`, { dic_schedule_id: that.activeScheduleId, from: from, to: to, type: type }).then(data => {
                    if (data.length <= 0) {
                        this.$message.warning(`暂无导出数据`)
                        return
                    }
                    this.myaxios.export_excel_Extradata(
                        `api/Operation/Home/ExcelFile_Schedule`,
                        data,
                        `排班结果.xls`,
                        data[0].标题
                    )
                }).catch(e => {
                    console.log(e)
                })
            } else { // 其他页
                this.exportForm.dialogFormVisible = true
            }
        },
        exportByTime() {
            let that = this
            let from = this.$moment(that.exportForm.from_to[0]).format(`YYYY-MM-DD`)
            let to = this.$moment(that.exportForm.from_to[1]).format(`YYYY-MM-DD`)
            let type = that.viewType == `day` ? 1 : (that.viewType == `week` ? 2 : 3)
            this.myaxios.get(`/api/AcisSystem/ScheduleResult/GetScheduleResultForExport`, { dic_schedule_id: that.activeScheduleId, from: from, to: to, type: type }).then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                this.myaxios.export_excel_Extradata(
                    `api/Operation/Home/ExcelFile_Schedule`,
                    data,
                    `排班结果.xls`,
                    data[0].标题
                )
            }).catch(e => {
                console.log(e)
            })
        },
        printInfo(command) {
            let that = this
            // 当前页
            let docCode = ``
            let from = null
            let to = null
            if (that.viewType == `day`) {
                docCode = that.printForm.day_doc_code
                from = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
                to = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
            } else if (that.viewType == `month`) {
                docCode = that.printForm.month_doc_code
                from = that.start
                to = that.end
            } else {
                docCode = that.printForm.week_doc_code
                from = that.start
                to = that.end
            }
            if (command == `CurrentPage`) {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.$root.DOCUMENT[docCode],
                                id1: `${that.schedule_result.dic_schedule_id}`,
                                objId: ``,
                                from: this.$moment(from).format(`YYYYMMDDHHmm`),
                                to: this.$moment(to).format(`YYYYMMDDHHmm`)
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            } else { // 其他页
                this.printForm.dialogFormVisible = true
            }
        },
        printByTime() {
            let that = this
            this.printForm.dialogFormVisible = false
            let docCode = ``
            if (that.viewType == `day`) {
                docCode = that.printForm.day_doc_code
            } else if (that.viewType == `month`) {
                docCode = that.printForm.month_doc_code
            } else {
                docCode = that.printForm.week_doc_code
            }
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[docCode],
                            id1: `${that.schedule_result.dic_schedule_id}`,
                            objId: ``,
                            from: this.$moment(that.printForm.from_to[0]).format(`YYYYMMDDHHmm`),
                            to: this.$moment(that.printForm.from_to[1]).format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        copyPreWeek() {
            let that = this
            return new Promise(resolve => {
                let url = ``
                let url1 = ``
                let title = ``
                let prevStart = null
                let prevEnd = null
                let type = this.viewType == `day` ? 1 : (this.viewType == `week` ? 2 : 3)

                if (that.viewType == `week`) {
                    title = `周`
                    prevStart = that.$moment(that.start).subtract(1, `week`).startOf(`week`).format(`YYYY-MM-DD`)
                    prevEnd = that.$moment(that.start).subtract(1, `week`).endOf(`week`).format(`YYYY-MM-DD`)
                } else if (that.viewType == `month`) {
                    title = `月`
                    prevStart = that.$moment(that.start).subtract(1, `month`).startOf(`month`).format(`YYYY-MM-DD`)
                    prevEnd = that.$moment(that.start).subtract(1, `month`).endOf(`month`).format(`YYYY-MM-DD`)
                } else {
                    title = `天`
                    prevStart = that.$moment(that.day).subtract(1, `day`).format(`YYYY-MM-DD`)
                    prevEnd = that.$moment(that.day).subtract(1, `day`).format(`YYYY-MM-DD`)
                }
                url = `/api/AcisSystem/ScheduleResult/GetScheduleResult?dic_schedule_id=${that.activeScheduleId}&startDT=${prevStart}&endDT=${prevEnd}&type=${type}`
                url1 = `/api/AcisSystem/ScheduleResult/GetScheduleResult?dic_schedule_id=${that.activeScheduleId}&startDT=${that.start}&endDT=${that.end}&type=${type}`

                // 获取上一周/日/月排班记录
                let req = this.myaxios.get(url)
                // 获取本周/日/月排班记录
                let req1 = this.myaxios.get(url1)
                this.myaxios.all(req, req1).then(([preSchedule, Schedule]) => {
                    if (!preSchedule || (preSchedule && preSchedule.id == 0 && preSchedule.result_details.length == 0)) {
                        this.$message.warning(`上一${title}没有排班记录!`)
                        return
                    }
                    let preYear = null
                    let premonth = null
                    let preweek = null
                    let preDt = null
                    if (preSchedule && preSchedule.id == 0) {
                        let dt = preSchedule.result_details[0].schedule_date
                        preYear = that.$moment(dt).year()
                        premonth = that.$moment(dt).month() + 1
                        preweek = that.$moment(dt).week()
                        preDt = that.$moment(dt).format(`YYYY-MM-DD`)
                    } else {
                        preYear = preSchedule.year
                        premonth = preSchedule.month
                        preweek = preSchedule.week
                        preDt = preSchedule.schedule_dt
                    }
                    if ((Schedule && (Schedule.id !== 0 || (Schedule.id == 0 && Schedule.result_details.length > 0)))) {
                        return that.$confirm(`当前日期已经有排班记录,复制上一${title}将覆盖当前数据,请确认`, `确认提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            that.copyPost(preYear, premonth, preweek, preDt)
                        }).catch(e => {

                        })
                    } else {
                        return that.$confirm(`是否确认复制上一${title}排班到当前列表`, `确认提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            that.copyPost(preSchedule.year, preSchedule.month, preSchedule.week, preSchedule.schedule_dt)
                        }).catch(e => {

                        })
                    }
                })
            })
        },
        copyPost(prevyear, premonth, prevweek, preday) {
            let that = this
            let type = that.viewType == `day` ? 1 : (that.viewType == `week` ? 2 : 3)
            let copydata = {
                dic_schedule_id: that.activeScheduleId,
                preyear: prevyear,
                preweek: prevweek,
                premonth: premonth,
                preday: preday,
                year: that.year,
                week: that.week,
                month: that.month,
                start_dt: that.start,
                end_dt: that.end,
                day: that.day,
                type: type
            }
            let url = `/api/AcisSystem/ScheduleResult/CopyPre?type=${type}`
            var reps = this.myaxios.post(url, copydata)
            reps.then(data => {
                this.loadScheduleResultsAndCreateShiftTable()
            })
        },
        publishHisRecord() {
            let that = this

            that.publishRecord.dialogFormVisible = true

            return new Promise(resolve => {
                var reps = this.myaxios.get(`/api/AcisSystem/ScheduleResult/GetSchedulePublishLog`, { begin: that.rdate[0], end: that.rdate[1] })
                reps.then(data => {
                    // that.publishRecord.data = data

                    that.publishRecord.data = _.map(data, (d) => {
                        d.dic_section = this.getSectionNameById(d.dic_section_id)
                        d.dic_ward = this.getWardNameById(d.dic_ward_id)
                        return d
                    })

                    resolve()
                })
            })
        },
        getDicShiftById(id) {
            let that = this
            return _.find(that.schedule_sifts, x => x.dic_shift_id == id)
        },
        getDicShiftName(id) {
            let that = this
            let item = _.find(that.schedule_sifts, x => x.dic_shift_id == id)
            if (item) { return item.dic_shift_name || `` }
            return ``
        },
        getSectionNameById(id) {
            if (!id) return ``
            let item = _.find(this[`section_auth`], x => x.value == parseInt(id))
            if (item) { return item.label || `` }
            return ``
        },
        getWardNameById(id) {
            if (!id) return ``
            let item = _.find(this[`ward_auth`], x => x.value == id)
            if (item) { return item.label || `` }
            return ``
        }
    },
    watch: {
        activeScheduleId: function() {
            if (this.activeScheduleId != 0) {
                let item = _.find(this.schedules, x => x.id == this.activeScheduleId)
                if (item) {
                    this.activeSchedule = item
                }
                this.loadActiveScheduleUserGroupsAndShifts(this.activeScheduleId).then((sifts) => {
                    this.loadScheduleResultsAndCreateShiftTable()
                })
            }
        },
        scheduleSet_Type: function() {
            this.loadScheduleResultsAndCreateShiftTable()
        },
        dateValue: function() {
            let that = this
            that.changeDatePickerSetScheduleTimeSpan(that.dateValue, 0)
            if (this.activeScheduleId != 0) {
                this.loadScheduleResultsAndCreateShiftTable()
            }
        },
        viewType: function() {
            this.dateValue = this.$moment()
        },
        rdate: function() {
            this.publishHisRecord()
        }

    }
}
</script>
<style scoped lang="less">
.schedulesetup {
    background: #ffffff;
    height: 100%;
    /deep/ .el-table th > .cell {
        height: auto !important;
        line-height: inherit !important;
    }
    /deep/ .el-header {
        height: 48px !important;
        padding: 0 0px;
        background: #ffffff;
    }
    /deep/ .el-main {
        padding: 0 0px;
    }
    /deep/ .el-footer {
        font-size: 22px;
        padding: 0px 0px;
    }
    /deep/ .calendartable {
        width: 100%;
    }

    /deep/ .el-table tbody tr:hover > td {
        // background: #ffffff !important;
    }

    /deep/ .el-table th {
        background: #ffffff !important;
    }

    /deep/ .el-dialog__wrapper .el-dialog__body .el-form-item__label {
        width: 130px !important;
        padding-top: 8px;
    }

    /deep/ .el-dialog__wrapper .el-dialog__body .el-form-item__content {
        margin-left: 140px !important;
    }

    /deep/ .el-tag--warning {
        color: orange;
        border: 1px solid orange;
        // height: 28px;
        // line-height: 28px;
    }
    /deep/ .el-select__tags {
        padding-left: 3px;
    }
    /deep/ .item {
        .item__txt {
            min-height: 150px !important;
            box-sizing: border-box;
            // border: 1px solid transparent;
        }
        .item__txt--hover {
            border: 1px solid #dddddd;
            border-radius: 4px;
            cursor: pointer;
            background-color: #ffffff;
        }
        .item__txt--click {
            border: 2px solid #0c9781;
            background-color: #ffffff;
        }
    }

    /deep/ .elSelect-Class {
        .el-input {
            input {
                height: 36px !important;
            }
        }
    }
    /deep/ .setworkerdialog {
        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            background: none;
            min-height: 100px !important;
        }

        .remotemultiselect {
            .el-input {
                input {
                    min-height: 80px !important;
                    width: 340px;
                }
            }
            .el-input__inner {
                padding-left: 5px !important;
            }
            &.el-input--suffix .el-input__inner {
                padding-right: 5px !important;
            }
            .el-input--suffix .el-input__inner {
                padding-right: 5px !important;
            }
            .el-input__prefix {
                display: none;
            }
            .el-select__input {
                padding-left: 4px;
            }
        }
    }
}
/deep/ .el-submenu__title {
    padding-left: 0px !important;
}
.user {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 2px 10px;
    margin: 2px 10px 5px 2px;
    border: solid 0px;
    border-radius: 3px;
    background: #ebeef5;
    cursor: move;
    line-height: 40px !important;
    height: 40px !important;
    font-size: 20px;
    color: #2c3e50 !important;
}
.shift {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 2px 10px;
    margin: 5px 10px 5px 2px;
    height: 30px;
    line-height: 30px;
    border: solid 0px;
    border-radius: 3px;
    background: #ebeef5;
    cursor: move;
    font-size:15px;
    color: #414d6c;
}
.userlisttitle {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    padding-left: 20px;
    border-bottom: 2px solid #ebeef5;
}
.usertag {
    margin-right: 5px;
    margin-bottom: 3px;
    min-width: 83px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 170px;
}

/deep/ .el-tabs__nav-wrap::after{
    background-color: #ffffff !important;
}

.btn-group-custom-style{
    /deep/ .el-button {
        &:not(:first-of-type){
            margin-left: 0 !important;
            border-left-width: 0;
        }

        &:not(:last-of-type){
            margin-right: 0 !important;
            border-right-width: 0;
        }
    }
}

.ver-hori-center{
    display: flex;
    justify-content: center;
    align-items: center;
}

.schedulesetup /deep/ .el-table th {
    background-color: #fafafa !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ScheduleShift/ScheduleSetup.vue